var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"height":"100vh","overflow-y":"hidden"},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticStyle:{"height":"100%"}})],1),_c('modal-vuetify-modal-layer-legacy'),_c('dialog-overlay'),_c('snackbar-overlay'),_c('loading-overlay-layer-legacy'),_c('block-overlay-layer-legacy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }